import React, { useCallback, useEffect, memo } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Input, {
  DatePickerComponent,
  ExtraInputComponent,
  SelectComponent,
} from "../../Common/FilterInput";

import { yupResolver } from "@hookform/resolvers/yup";

import { setTicketFilter } from "../../../store/managerTickets/actions";

import { useForm } from "react-hook-form";
import schema from "./filterValidation";

import ConversationFilterCardInput from "../../Common/ConversationFilterCardInput";

import "./style.scss";
import { useState } from "react";
import { getTabsBySkill } from "../../../store/manager/actions";

const optionsPersonalInformation = [
  { value: "document", label: "Document" },
  { value: "phone", label: "phone" },
  { value: "email", label: "E-mail" },
];

function FilterComponent() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { mainTheme } = useSelector((state) => state.Layout);

  const { register, handleSubmit, errors, setValue, getValues } = useForm({
    resolver: yupResolver(schema),
  });

  const filter = useSelector((state) => state.ManagerTickets.filter);
  const isOpen = useSelector((state) => state.ManagerTickets.showFilter);
  const { skills, agents, status } = useSelector((state) => state.ManagerTickets.forms);
  const [originalFirstLevelTabs, setOriginalFirstLevelTabs] = useState([]);
  const [originalSecondLevelTabs, setOriginalSecondLevelTabs] = useState([]);
  const [originalThirdLevelTabs, setOriginalThirdLevelTabs] = useState([]);
  const [firstLevelTabs, setFirstLevelTabs] = useState([]);
  const [secondLevelTabs, setSecondLevelTabs] = useState([]);
  const [thirdLevelTabs, setThirdLevelTabs] = useState([]);
  const [selectedFirstLevelTab, setSelectedFirstLevelTab] = useState([]);
  const [selectedSecondLevelTab, setSelectedSecondLevelTab] = useState([]);
  const [selectedThirdLevelTab, setSelectedThirdLevelTab] = useState([]);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [filterCustom, setFilterCustom] = useState({});

  const clearFilters = useCallback(() => {
    setFilterCustom({});
    setSelectedFirstLevelTab([]);
    setSelectedSecondLevelTab([]);
    setSelectedThirdLevelTab([]);
  }, []);

  const handleSubmitForm = useCallback(
    (data) => {
      dispatch(
        setTicketFilter({
          ...data,
          ...filterCustom,
        })
      );
      selectedFirstLevelTab?.length > 0 && clearFilters();
    },
    [dispatch, filterCustom, selectedFirstLevelTab?.length, clearFilters]
  );

  const tabs = useSelector((state) => {
    return state?.Manager?.tabs;
  });

  useEffect(() => {
    const localFirstLevelTabs = [];
    const localSecondLevelTabs = [];
    const localThirdLevelTabs = [];
    if (tabs?.length > 0) {
      tabs.forEach((tab) => {
        localFirstLevelTabs.push({
          value: tab?.id,
          label: tab?.name,
          skillId: tab?.skill_id,
          global: tab?.global,
        });
        if (tab?.children) {
          if (tab?.children?.length > 0) {
            tab.children.forEach((firstChildTab) => {
              localSecondLevelTabs.push({
                value: firstChildTab?.id,
                fatherId: tab.id,
                label: firstChildTab?.name,
                skillId: firstChildTab?.skill_id,
                global: firstChildTab?.global,
              });
              if (firstChildTab?.children?.length > 0) {
                firstChildTab.children.forEach((secondChildTab) => {
                  localThirdLevelTabs.push({
                    value: secondChildTab?.id,
                    grandfatherId: firstChildTab?.id,
                    label: secondChildTab?.name,
                    skillId: secondChildTab?.skill_id,
                    global: secondChildTab?.global,
                  });
                });
              }
            });
          }
        }
      });
    }
    setFirstLevelTabs(localFirstLevelTabs);
    setSecondLevelTabs(localSecondLevelTabs);
    setThirdLevelTabs(localThirdLevelTabs);
    setOriginalFirstLevelTabs(localFirstLevelTabs);
    setOriginalSecondLevelTabs(localSecondLevelTabs);
    setOriginalThirdLevelTabs(localThirdLevelTabs);
  }, [tabs]);

  useEffect(() => { }, [errors]);

  useEffect(() => {
    const filteredSecondLevelTabs = [];
    secondLevelTabs.forEach((secondLevelTab) => {
      if (selectedFirstLevelTab !== null) {
        selectedFirstLevelTab.forEach((selectedTab) => {
          if (secondLevelTab?.fatherId === selectedTab?.value) {
            filteredSecondLevelTabs.push(secondLevelTab);
          }
        });
      }
    });
    if (selectedFirstLevelTab === null) {
      setSecondLevelTabs(originalSecondLevelTabs);
      setFilterCustom({
        ...filterCustom,
        tabs: [],
      });
    } else {
      setSecondLevelTabs(filteredSecondLevelTabs);
    }
  }, [selectedFirstLevelTab]);

  useEffect(() => {
    const filteredThirdLevelTabs = [];
    thirdLevelTabs.forEach((thirdLevelTab) => {
      if (selectedSecondLevelTab !== null) {
        selectedSecondLevelTab.forEach((selectedTab) => {
          if (thirdLevelTab?.grandfatherId === selectedTab?.value) {
            filteredThirdLevelTabs.push(thirdLevelTab);
          }
        });
      }
    });
    if (selectedSecondLevelTab === null) {
      const currentTabs = filterCustom?.tabs;
      if (currentTabs) {
        currentTabs.pop();
      }
      setThirdLevelTabs(originalThirdLevelTabs);
      setFilterCustom({
        ...filterCustom,
        tabs: currentTabs,
      });
    } else {
      setThirdLevelTabs(filteredThirdLevelTabs);
    }
  }, [selectedSecondLevelTab]);

  useEffect(() => {
    if (selectedThirdLevelTab === null) {
      const currentTabs = filterCustom?.tabs;
      if (currentTabs) {
        currentTabs.pop();
      }
      setFilterCustom({
        ...filterCustom,
        tabs: currentTabs,
      });
    }
  }, [selectedThirdLevelTab]);

  return (
    <div className={`filter-component ${mainTheme} ${!isOpen && "hidden"}`}>
      <div className="d-flex flex-row justify-content-between w-100">
        <h5>{t("Ticket Filter")}</h5>
        <ErrorForms />
      </div>

      <form
        className="content-filter"
        onSubmit={handleSubmit(handleSubmitForm)}
      >
  
        <div className="content-filter-input">
          <Input
            label={t("Protocol")}
            name="protocol"
            type="text"
            placeholder={t("Enter the protocol")}
            required
            innerRef={register}
            error={errors.protocol?.message}
            defaultValue={getValues("protocol") || filter.protocol}
          />
        </div>
        <div className="content-filter-input">
          <Input label={t("Skills")} required>
            <SelectComponent
              name="skills_id"
              options={skills}
              isMulti
              placeholder={t("Select skills") + "..."}
              error={errors.skills?.value?.message}
              register={() => register({ name: "skills_id" })}
              onChange={(e) => {
                if (e === null) {
                  setSelectedFirstLevelTab(null);
                  setSelectedSecondLevelTab(null);
                  setSelectedThirdLevelTab(null);
                  setFilterCustom({
                    ...filterCustom,
                    skills: [],
                  });
                  setValue("skills_id", null);
                } else {
                  if (e?.length > 0) {
                    dispatch(getTabsBySkill(e[e?.length - 1]?.value));
                    setValue("skills_id", e);
                    setFilterCustom({
                      ...filterCustom,
                      skills: e,
                    });
                  }
                }
              }}
              defaultValue={getValues("skills_id") || filter.skills_id}
            />
          </Input>
        </div>
        <div className="content-filter-input">
          <ConversationFilterCardInput
            filterCardInputTitle={t("Tab")}
            filterCardInputPlaceholder={"Nível 1"}
            addon
            select
            selectOptions={firstLevelTabs}
            isMulti
            onChange={(e) => {
              if (e) {
                if (e?.length === 1) {
                  setSelectedFirstLevelTab(e);
                  setFilterCustom({
                    ...filterCustom,
                    tabs: e,
                  });
                }
              } else {
                setSelectedFirstLevelTab(e);
                setSelectedSecondLevelTab(null);
                setSelectedThirdLevelTab(null);
              }
            }}
            value={selectedFirstLevelTab}
            noMargin
          />
        </div>
        {selectedFirstLevelTab?.length > 0 && (
          <div className="content-filter-input">
            <ConversationFilterCardInput
              filterCardInputTitle={""}
              filterCardInputPlaceholder={"Nível 2"}
              addon
              select
              selectOptions={secondLevelTabs}
              isMulti
              onChange={(e) => {
                if (e) {
                  if (e?.length === 1) {
                    setSelectedSecondLevelTab(e);
                    setFilterCustom({
                      ...filterCustom,
                      tabs: e.concat(...filterCustom?.tabs),
                    });
                  }
                } else {
                  setSelectedSecondLevelTab(e);
                  setSelectedThirdLevelTab(null);
                }
              }}
              value={selectedSecondLevelTab}
              noMargin
            />
          </div>
        )}
        {selectedSecondLevelTab?.length > 0 && (
          <div className="content-filter-input">
            <ConversationFilterCardInput
              filterCardInputTitle={""}
              filterCardInputPlaceholder={"Nível 3"}
              addon
              select
              selectOptions={thirdLevelTabs}
              isMulti
              onChange={(e) => {
                setSelectedThirdLevelTab(e);
                if (e) {
                  if (e?.length === 1) {
                    setSelectedThirdLevelTab(e);
                    setFilterCustom({
                      ...filterCustom,
                      tabs: e.concat(...filterCustom?.tabs),
                    });
                  }
                } else {
                  setSelectedThirdLevelTab(e);
                }
              }}
              value={selectedThirdLevelTab}
              noMargin
            />
          </div>
        )}
        <div className="content-filter-input">
          <Input label={t("Agent")} required>
            <SelectComponent
              name="agents_id"
              options={agents}
              placeholder={t("Select agent") + "..."}
              isClearable
              register={() => register({ name: "agents_id" })}
              onChange={(value) => {
                setValue("agents_id", value);
              }}
              error={errors.agent?.value?.message}
              defaultValue={getValues("agents_id") || filter.agents_id}
            />
          </Input>
        </div>
        <div className="content-filter-input">
          <Input
            label={t("Client")}
            name="client"
            type="text"
            placeholder={t("Enter customer name")}
            required
            innerRef={register}
            error={errors.client?.message}
            defaultValue={getValues("client") || filter.client}
          />
        </div>
        <div className="content-filter-input">
          <Input label={t("Personal information")}>
            <ExtraInputComponent
              name="personal_information"
              type="text"
              placeholder={t("Enter personal information")}
              options={optionsPersonalInformation}
              register={register}
              error={errors.personal_information}
              defaultValueTypes={
                getValues("personal_information.types") ||
                filter.personal_information?.types
              }
              defaultValue={
                getValues("personal_information.value") ||
                filter.personal_information?.value
              }
              onChangeSelect={(value) => {
                setValue("personal_information.types", value);
              }}
            />
          </Input>
        </div>
        <div className="content-filter-input">
          <Input label={t("Date")} required>
            <DatePickerComponent
              name="date"
              placeholderText={t("Date")}
              register={() => register({ name: "date" })}
              error={errors.date}
              onChange={(value) => {
                setValue("date", value);
              }}
              defaultValue={getValues("date") || filter.date}
            />
          </Input>
        </div>

        <div className="content-buttons-input">
          <SubmitButton label={t("Search")} />
        </div>
      </form>
    </div>
  );
}

export default memo(FilterComponent);

const SubmitButton = memo(({ label }) => {
  const status = useSelector((state) => state.ManagerTickets.status);

  const isDisabled = status.table.loading;

  return (
    <button
      type="submit"
      className="btn btn-primary"
      disabled={isDisabled}
      style={{
        width: 71,
      }}
    >
      {isDisabled ? (
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        label
      )}
    </button>
  );
});

const ErrorForms = memo(() => {
  const status = useSelector((state) => state.ManagerTickets.status.forms);
  const { t } = useTranslation();

  return (
    <>
      {status.error && (
        <div
          title={t(
            "Sorry! something went wrong, please contact our support team"
          )}
        >
          <i className="fa fa-exclamation-triangle text-danger mr-2" />
        </div>
      )}

      {status.loading && (
        <div>
          <i className="bx bx-loader bx-spin text-primary mr-2" />
        </div>
      )}
    </>
  );
});
